// src/components/blog/BlogPost.js
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import styles from '../../styles/pages/Blog.module.css';
import { updateUrlForPost } from '../../utils/urlUtils';

/**
 * BlogPost component for displaying individual blog posts
 * With hash router URL support
 */
export const BlogPost = ({ id, title, date, description, tags = [], content }) => {
  // Handle link clicks within blog post to update URL correctly
  React.useEffect(() => {
    const handlePostClick = () => {
      // Update URL with correct hash format for this post
      updateUrlForPost(id);
    };
    
    // Get post element
    const postElement = document.getElementById(`post-${id}`);
    
    if (postElement) {
      postElement.addEventListener('click', handlePostClick);
      
      return () => {
        postElement.removeEventListener('click', handlePostClick);
      };
    }
  }, [id]);

  return (
    <article id={`post-${id}`} className={styles.post}>
      <header className={styles.postHeader}>
        <h2>{title}</h2>
        <span className={styles.postDate}>{date}</span>
      </header>
      
      {description && (
        <div className={styles.postDescription}>{description}</div>
      )}
      
      <div className={styles.postContent}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {content}
        </ReactMarkdown>
      </div>
      
      {tags.length > 0 && (
        <div className={styles.tagContainer}>
          {tags.map((tag, index) => (
            <span key={index} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      )}
    </article>
  );
};

export default BlogPost;